import * as React from "react";
import {authReducer} from "../context/authReducer";
import {useReducer} from "react";


const initialState = false;

const AuthContext = React.createContext(false);

const withAuthContext = (Component) => {
    return props => {
        const [state, dispatch] = useReducer(authReducer,initialState);
        return (
            <AuthContext.Provider value={{state, dispatch}}>
                <Component {...props}></Component>
            </AuthContext.Provider>
        )

    }
}

const AuthContextProvider = ({children}) => {

    const [state, dispatch] = useReducer(authReducer, [])

    return (
        <AuthContext.Provider value={ { state, dispatch } }>
            {children}
        </AuthContext.Provider>
    )
}

export {AuthContext, withAuthContext, AuthContextProvider}
